import React, { useEffect, useMemo, useState } from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { EModePanelSelect } from './SelectPanel';
import { IOptionData } from 'models/OptionData';
import {
  updateSelectBranch,
  updateSelectStatus,
  updateSelectCustomer,
  updateSelectOrder,
  // updateSelectCategory,
  updateSelectStaff,
  updateSelectStock,
  updateCompanyName,
  updateCoopType,
  updateTime,
  updateListSales,
  updateLPaymentMethod,
  updateTypeBranch,
  updateListSalesV2,
  updateIsBlock,
  updateSelectListSalesV2,
  updateCoopTypeV2,
  updateOperateCollected,
  updateAccountCollected,
  updateListOperating,
  updateListAccountant,
  updateListTechBranch,
  updateListOperatingBranch,
  updateListAccountantBranch,
  updateTypeCompany,
  updateWallteState,
  updateWallteType,
  updateSender,
  updateReceiver,
  updateAdjustmentTypes,
  updateSelectListSalesV3,
  updateSupportTicketBranch,
  updateSupportTicketState
} from '@slice/select.slice';
import styled from 'styled-components';
import { RootState } from 'app/store';

interface ISingleSelect {
  options: Array<IOptionData>;
  value?: IOptionData;
  type?: EModePanelSelect;
  initial?: Array<string>;
  minWidth?: string;
  placeHoder?: string;
  checkType?: string;
  defaultValue?: any;
  onChange?: (value: any) => void;
  isMutipleOrder?: any;
}

// export const SelectStyle: any = styled(Select)`
//   &.ant-select .ant-select-selector {
//     white-space: nowrap !important;
//     max-width: 270px;
//     min-width: 1px;
//     height: 32px;
//   }
// `;

const SingleSelect = React.memo((props: ISingleSelect) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const data = useSelector((state: RootState) => state.admin.allUser);
  const resetTime = useSelector((state: RootState) => state.select.resetTime);
  const dataAccountant = useSelector((state: RootState) => state.admin.allUserAccountant);
  const dataOperating = useSelector((state: RootState) => state.admin.allUserOperating);

  const [selected, setSelected] = useState<any>();
  const [arraySelect, setArraySelect] = useState<any[]>(['-1']);

  // Hàm xử lý chuyển tab thì clear select
  useEffect(() => {
    if (resetTime) {
      setArraySelect(['-1']);
      setSelected(
        props.type === EModePanelSelect.WalletStateTech
          ? 0
          : props.type === EModePanelSelect.Time
          ? 'TG Hoàn tất'
          : props.type === EModePanelSelect.TypeBranch
          ? 'CN thực hiện'
          : '-1'
      );
    }
  }, [resetTime]);

  // Hàm xử lý chuyển tab thì clear select
  // useEffect(() => {
  //   if (props.tabKeyActive) {
  //     setArraySelect(['-1']);

  //     // LOGIC MỚI CHO TechV2
  //     if (props.type === EModePanelSelect.TechV2 && props.options.length > 0) {
  //       setSelected(props.options[0].value);
  //     } else {
  //       setSelected(
  //         props.type === EModePanelSelect.Time
  //           ? 'TG Hoàn tất'
  //           : props.type === EModePanelSelect.TypeBranch
  //           ? 'CN thực hiện'
  //           : '-1'
  //       );
  //     }
  //   }
  // }, [props.tabKeyActive, props.options]); // Thêm props.options để bắt kịp data khi load xong

  const options = useMemo(() => {
    return props.options.map(item => (
      <Select.Option label={item.label} value={item.value} key={item.value}>
        {item.label}
      </Select.Option>
    ));
  }, [props.options]);

  useEffect(() => {
    // 1. CHECK CHO KỸ THUẬT (Tech, TechV2)
    if (props.type === EModePanelSelect.Tech || props.type === EModePanelSelect.TechV2) {
      const isStillValid = props.options.some(opt => opt.value === selected);

      if (!isStillValid && selected !== '-1' && selected !== undefined) {
        setSelected('-1');
        dispatch(updateSelectStaff('-1'));
      }
    }

    // 2. CHECK CHO ĐIỀU HÀNH (Operating) - MỚI THÊM
    if (props.type === EModePanelSelect.Operating) {
      // Kiểm tra xem người điều hành hiện tại có nằm trong danh sách chi nhánh mới không
      const isStillValid = props.options.some(opt => opt.value === selected);

      // Nếu người điều hành cũ không có trong chi nhánh mới
      if (!isStillValid && selected !== '-1' && selected !== undefined) {
        setSelected('-1'); // Reset hiển thị về "Tất cả"
        dispatch(updateListOperating('-1')); // Cập nhật store về mặc định
      }
    }

    // 3. CHECK CHO KẾ TOÁN (Accoutant) - MỚI THÊM
    if (props.type === EModePanelSelect.Accountant) {
      // Kiểm tra xem người điều hành hiện tại có nằm trong danh sách chi nhánh mới không
      const isStillValid = props.options.some(opt => opt.value === selected);

      // Nếu người điều hành cũ không có trong chi nhánh mới
      if (!isStillValid && selected !== '-1' && selected !== undefined) {
        setSelected('-1'); // Reset hiển thị về "Tất cả"
        dispatch(updateListAccountant('-1')); // Cập nhật store về mặc định
      }
    }
  }, [props.options]); // Chạy lại mỗi khi danh sách options (đã lọc theo chi nhánh) thay đổi

  useEffect(() => {
    if (
      (props.type === EModePanelSelect.Staff ||
        props.type === EModePanelSelect.Sell ||
        props.type === EModePanelSelect.Tech ||
        props.type === EModePanelSelect.TechV2) &&
      selected
    ) {
      dispatch(updateSelectStaff(selected));
    } else if (props.type === EModePanelSelect.Operating) {
      dispatch(updateListOperating(selected));
    } else if (props.type === EModePanelSelect.Accountant) {
      dispatch(updateListAccountant(selected));
    } else if (props.type === EModePanelSelect.Stock) {
      dispatch(updateSelectStock(selected));
    } else if (props.type === EModePanelSelect.Customer) {
      dispatch(updateSelectCustomer(selected));
    } else if (props.type === EModePanelSelect.Category) {
      // dispatch(updateSelectCategory(selected));
    } else if (props.type === EModePanelSelect.Order) {
      dispatch(updateSelectOrder(selected));
    } else if (props.type === EModePanelSelect.Branch) {
      dispatch(updateSelectBranch(selected));
    } else if (props.type === EModePanelSelect.BranchV2) {
      const filteredTechnicians = data
        .filter(
          item => !item.isLocked && item.role === 'Technician' && item.companyBranchId === selected // Lọc theo chi nhánh được chọn ở đây
        )
        .map(item => ({ value: item.username, label: item.username }))
        .sort((a, b) => a.value.localeCompare(b.value, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }));

      const filteredOperatings = dataOperating
        .filter(item => !item.isLocked && item.companyBranchId === selected) // Lọc theo chi nhánh được chọn ở đây
        .map(item => ({ value: item.username, label: item.username }))
        .sort((a, b) => a.value.localeCompare(b.value, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }));

      const filteredAccountants = dataAccountant
        .filter(item => !item.isLocked && item.companyBranchId === selected) // Lọc theo chi nhánh được chọn ở đây
        .map(item => ({ value: item.username, label: item.username }))
        .sort((a, b) => a.value.localeCompare(b.value, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }));

      dispatch(updateListAccountantBranch(filteredAccountants));
      dispatch(updateListTechBranch(filteredTechnicians));
      dispatch(updateListOperatingBranch(filteredOperatings));
      dispatch(updateSelectBranch(selected));
    } else if (props.type === EModePanelSelect.Status) {
      dispatch(updateSelectStatus(selected));
    } else if (props.type === EModePanelSelect.CompanyName) {
      dispatch(updateCompanyName(selected));
    } else if (props.type === EModePanelSelect.TypeCompany) {
      dispatch(updateTypeCompany(selected));
    } else if (props.type === EModePanelSelect.OperateCollected) {
      dispatch(updateOperateCollected(selected));
    } else if (props.type === EModePanelSelect.AccountantCollected) {
      dispatch(updateAccountCollected(selected));
    } else if (props.type === EModePanelSelect.CoopType) {
      dispatch(updateCoopType(selected));
    } else if (props.type === EModePanelSelect.CoopTypeV2) {
      dispatch(updateCoopTypeV2(selected));
    } else if (props.type === EModePanelSelect.Time) {
      dispatch(updateTime(selected));
    } else if (props.type === EModePanelSelect.ListSales) {
      dispatch(updateListSales(selected));
    } else if (props.type === EModePanelSelect.ListSalesV2) {
      dispatch(updateSelectListSalesV2(selected));
    } else if (props.type === EModePanelSelect.ListSalesV3) {
      dispatch(updateSelectListSalesV3(selected));
    } else if (props.type === EModePanelSelect.IsBlock) {
      dispatch(updateIsBlock(selected));
    } else if (props.type === EModePanelSelect.PaymentMethod) {
      dispatch(updateLPaymentMethod(selected));
    } else if (props.type === EModePanelSelect.TypeBranch) {
      dispatch(updateTypeBranch(selected));
    } else if (props.type === EModePanelSelect.WalletState) {
      dispatch(updateWallteState(selected));
    } else if (props.type === EModePanelSelect.WalletStateTech) {
      dispatch(updateWallteState(selected));
    } else if (props.type === EModePanelSelect.WalletType) {
      dispatch(updateWallteType(selected));
    } else if (props.type === EModePanelSelect.AdjustmentTypes) {
      dispatch(updateAdjustmentTypes(selected));
    } else if (props.type === EModePanelSelect.SupportBranch) {
      dispatch(updateSupportTicketBranch(selected));
    } else if (props.type === EModePanelSelect.SupportState) {
      dispatch(updateSupportTicketState(selected));
    } else if (props.type === EModePanelSelect.Sender) {
      dispatch(updateSender(selected));
    } else if (props.type === EModePanelSelect.Receiver) {
      dispatch(updateReceiver(selected));
    }
  }, [selected]);

  const handleChange = (value: any[]) => {
    if (props?.isMutipleOrder?.includes(props.type)) {
      let finalValues = [...value];

      if (finalValues.length === 0) {
        finalValues = ['-1'];
      }
      // Nếu đang có cả '-1' (Tất cả) và mục khác => bỏ '-1'
      if (finalValues.includes('-1') && finalValues.length > 1) {
        finalValues = finalValues.filter(v => v !== '-1');
      }

      // Nếu người dùng chọn lại duy nhất "-1"
      if (value[value.length - 1] === '-1') {
        finalValues = ['-1'];
      }

      setArraySelect(finalValues);

      const newArray = finalValues.map(val => (val === '-1' ? 0 : val));
      setSelected({ data: newArray, type: 'mutiple' });
      props.onChange && props.onChange(newArray);
    } else {
      setSelected(value);
      props.onChange && props.onChange(value);
    }
  };

  useEffect(() => {
    // Nếu là TechV2 và chưa có giá trị được chọn (hoặc đang là mặc định)
    if (props.type === EModePanelSelect.TechV2 && (!selected || selected === '-1') && props.options.length > 0) {
      const firstVal = props.options[0].value;
      setSelected(firstVal);
    }
  }, [props.options, props.type]);

  return (
    <>
      <span className="text-xs font-semibold flex !flex-col z-50">
        {props.type === EModePanelSelect.Order
          ? 'Loại đơn hàng'
          : props.type === EModePanelSelect.Branch
          ? 'Chi nhánh'
          : props.type === EModePanelSelect.BranchV2
          ? 'Chi nhánh'
          : props.type === EModePanelSelect.Status
          ? 'Trạng thái đơn'
          : props.type === EModePanelSelect.Tech
          ? 'Chọn kỹ thuật'
          : props.type === EModePanelSelect.TechV2
          ? 'Chọn kỹ thuật'
          : props.type === EModePanelSelect.Operating
          ? 'Chọn điều hành'
          : props.type === EModePanelSelect.Accountant
          ? 'Chọn kế toán'
          : props.type === EModePanelSelect.CompanyName
          ? 'Tìm theo công ty'
          : props.type === EModePanelSelect.TypeCompany
          ? 'Tìm theo loại'
          : props.type === EModePanelSelect.OperateCollected
          ? 'Trạng thái (Điều hành)'
          : props.type === EModePanelSelect.AccountantCollected
          ? 'Trạng thái (Kế toán)'
          : props.type === EModePanelSelect.CoopType
          ? 'Loại hình hợp tác'
          : props.type === EModePanelSelect.CoopTypeV2
          ? 'Loại hình hợp tác'
          : props.type === EModePanelSelect.Time
          ? 'Tìm theo thời gian'
          : props.type === EModePanelSelect.ListSales || props.type === EModePanelSelect.ListSalesV3
          ? 'Tìm theo KD'
          : props.type === EModePanelSelect.IsBlock
          ? 'Khóa tài khoản'
          : props.type === EModePanelSelect.ListSalesV2
          ? 'NV quản lý'
          : props.type === EModePanelSelect.PaymentMethod
          ? 'Tìm theo HTTT'
          : props.type === EModePanelSelect.WalletState || props.type === EModePanelSelect.WalletStateTech
          ? 'Trạng thái'
          : props.type === EModePanelSelect.WalletType
          ? 'Loại'
          : props.type === EModePanelSelect.Sender
          ? 'Người gửi'
          : props.type === EModePanelSelect.AdjustmentTypes
          ? 'Loại phiếu'
          : props.type === EModePanelSelect.SupportBranch
          ? 'Công ty'
          : props.type === EModePanelSelect.SupportState
          ? 'Nhóm hỗ trợ' // giá trị là id nhóm hỗ trợ (supportTicketState), không phải trạng thái phiếu
          : props.type === EModePanelSelect.Receiver
          ? props.checkType === 'vikythuat'
            ? 'Kỹ thuật'
            : 'Người nhận'
          : props.type === EModePanelSelect.TypeBranch
          ? 'Loại chi nhánh'
          : ''}
      </span>

      {props?.isMutipleOrder?.includes(props.type) ? (
        <>
          <Select
            style={{
              width:
                props.type === EModePanelSelect.Time && (props.checkType == 'theodon' || props.checkType === 'congno')
                  ? '150px'
                  : props.checkType === 'quanlyphieu'
                  ? '180px'
                  : props.minWidth || '100%'
            }}
            showSearch
            allowClear
            autoClearSearchValue
            mode="multiple"
            maxTagCount={props.type === EModePanelSelect.ListSalesV2 ? 1 : 2}
            placeholder={props.initial || 'Tất cả'}
            onChange={handleChange}
            // value={props.value?.value?.toString()}
            value={arraySelect}
            defaultValue={arraySelect}

            // value={props.value?.value?.toString() || selected}
            // defaultValue={props.defaultValue}
          >
            {options}
          </Select>
        </>
      ) : (
        <Select
          style={{
            width:
              props.type === EModePanelSelect.Time && (props.checkType == 'theodon' || props.checkType === 'congno')
                ? '150px'
                : props.checkType === 'quanlyphieu'
                ? '180px'
                : props.minWidth || '100%'
          }}
          showSearch
          allowClear
          placeholder={props.initial || 'Tất cả'}
          onChange={handleChange}
          // V.1.2.53 -> Đã comment ở bản này nếu cần chỉnh lại sau
          //  || props.defaultValue
          value={props.value?.value?.toString() || selected} // Thêm select khi chuyển tab để hiển tất mặc định -1 khi props.value không có
          defaultValue={
            props.type === EModePanelSelect.WalletStateTech
              ? 0
              : props.defaultValue === 0
              ? 0
              : props.defaultValue || null
          }
        >
          {options}
        </Select>
      )}
    </>
  );
});

SingleSelect.displayName = 'SingleSelect';

export default SingleSelect;
